import React, { Component } from 'react';

class Logo extends Component {
  render() {
    return (
      <div className="logo">
			  <a href="/"><img src="images/logo.png" /> Pemiscot Dunklin Fiber</a><span> Powered by Pemiscot Dunklin Electric Cooperative</span>
      </div>
    );
  }
}

export default Logo;


// WEBPACK FOOTER //
// ./src/components/Logo.js